import React, { useMemo } from 'react';
import times from 'lodash/times';
import classnames from 'classnames';
import styles from './Pagination.module.scss';
import { getTemplateString } from 'common/helpers/string';

interface Props {
  currentPage: number;
  numberOfPages: number;
  numberOfPagesToDisplay?: number;
  lengthpage:number;
  onChange: (currentPage: number) => void;
  
}




const Pagination = ({
  currentPage = 1,
  numberOfPages,
  lengthpage,
  onChange,
}: Props) => {

  const paginationNumbers = [];

  for (let i = 1; i <= numberOfPages; i++) {
    paginationNumbers.push(i);
  }
  
    return (
      <>
        <div className={styles.Pagination}>
          <div className={styles.controls}>
            <button
              className={classnames(styles.controlBtn, styles.goFirstBtn)}
              onClick={() => onChange(1)}
            >
              {'<<'}
            </button>
            <button
              className={classnames(styles.controlBtn, styles.prevBtn)}
              onClick={() => currentPage > 1 && onChange(currentPage - 1)}
            >
              {'<'}
            </button>
          </div>
          <div className={styles.pages}>
            {(paginationNumbers || []).map((index: number) => {
              return (
                <button
                  className={classnames(
                    styles.index,
                    index === currentPage && styles.activeIndex,
                  )}
                  onClick={() => onChange(index)}
                >
                  {index}
                </button>
              );
            })}
          </div>
          <div className={styles.controls}>
            <button
              className={classnames(styles.controlBtn, styles.nextBtn)}
              onClick={() =>
                currentPage < numberOfPages && onChange(currentPage + 1)
              }
            >
              {'>'}
            </button>
            <button
              className={classnames(styles.controlBtn, styles.goLastBtn)}
              onClick={() => onChange(numberOfPages)}
            >
              {'>>'}
            </button>
          </div>
        </div>
       
      </>
    );

};

export default Pagination;
